import React from "react";
import "./NewsletterCollector.css";
import { useState } from "react";
import { useAuth } from "../../Auth/useAuth";
import UiButton, { UI_BUTTON_TYPE } from "../../ui/UiButton";
import UiDropdown from "../../ui/UiDropdown";
import UiInput from "../../ui/UiInput";
import { Container } from "react-bootstrap";
import { ICON } from "../../../assets";
import UiIcon from "../../ui/UiIcon";
import sdk from "../../../sdk/sdk";
import { useDispatch, useSelector } from "react-redux";
import { showSnackbar } from "../../Snackbar/actions";

const NewsletterCollector = ({ close }) => {
  const [auth] = useAuth();
  const dispatch = useDispatch();

  const salesSource = [
    { value: "institut", label: "institut" },
    { value: "parfumerie", label: "parfumerie" },
    { value: "concept store", label: "concept store" },
    { value: "pharmacie", label: "pharmacie" },
    { value: "autre", label: "autre" },
  ];
  const configDepartments = useSelector(
    (state) => state.config.configuration.departments,
  );
  const department = !!configDepartments
    ? configDepartments.map((value) => {
        return {
          value: value,
          label: value,
        };
      })
    : [];
  const [formData, setFormData] = useState({
    email:
      auth.user && auth.user.client_profile?.email
        ? auth.user.client_profile?.email
        : auth.user.data?.email,
    lastName: "",
    firstName: "",
    salesSource: "",
    department: "",
    userId:
      auth.user && auth.user.client_profile?.id
        ? auth.user.client_profile?.id
        : auth.user?.id,
  });
  const [isformInValid, setIsFormInValid] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDropdownSelect = (name, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (event,isFormInValid) => {
    event.preventDefault();
    setIsFormInValid(isFormInValid);
    if (isFormInValid) {
      return false;
    }
    await sdk.users.newsletter(formData).then((response) => {
      if (response.success === false) {
        dispatch(
          showSnackbar({
            label:
              "Une erreur s'est produite. Veuillez vérifier vos informations et réessayer.",
            type: "error",
            open: true,
            delay: 5000,
          }),
        );
        return;
      }
      dispatch(
        showSnackbar({
          label:
            "Vous êtes abonné ! Vous recevrez désormais nos dernières actualités et mises à jour.",
          type: "success",
          open: true,
          delay: 5000,
        }),
      );
      close();
    });
  };
  const isFormInValid =
    !formData.email ||
    !formData.lastName ||
    !formData.firstName ||
    !formData.salesSource ||
    !formData.department;
  return (
    <React.Fragment>
      <UiIcon
        icon={ICON.closeCrossIcon}
        alt="Close"
        className="close-icon"
        onClick={() => close()}
        size="md"
      />
      <Container fluid className="newsletter-collector-container">
        <div className="newsletter-collector-header">
          <div className="newsletter-collector-title">
            Ne manquez plus aucune offre : inscrivez-vous à la newsletter
            professionelle Blancrème !
          </div>
        </div>
        <form onSubmit={handleSubmit} className="newsletter-collector-form">
          {isFormInValid && <div className="form-validation-error">
            Tous les champs sont obligatoires.
          </div>}
          <div className="form-group">
            <label htmlFor="email">Adresse mail :</label>
            <UiInput
              name="email"
              value={formData.email}
              onChange={handleChange}
              throwError={isformInValid && !formData?.email}
              required={true}
            />
          </div>
          <div className="form-group">
            <label htmlFor="lastName">Nom :</label>
            <UiInput
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              throwError={isformInValid && !formData?.lastName}
              required={true}
            />
          </div>
          <div className="form-group">
            <label htmlFor="firstName">Prénom :</label>
            <UiInput
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              throwError={isformInValid && !formData?.firstName}
              required={true}
            />
          </div>
          <div className="form-group">
            <label htmlFor="salesSource">Votre point de vente :</label>
            <UiDropdown
              options={salesSource}
              onSelect={(option) =>
                handleDropdownSelect("salesSource", option ? option.value : "")
              }
              name="salesSource"
              value={formData.salesSource}
              throwError={isformInValid && !formData.salesSource}
              required={true}
            />
          </div>
          <div className="form-group">
            <label htmlFor="department">Département :</label>
            <UiDropdown
              options={department}
              onSelect={(option) =>
                handleDropdownSelect("department", option ? option.value : "")
              }
              name="department"
              value={formData.department}
              throwError={isformInValid && !formData.department}
              required={true}
            />
          </div>
          <div className="form-button-group">
            <UiButton
              content="Annuler et fermer"
              onClick={() => close()}
              buttonUiType={[UI_BUTTON_TYPE.ONLY_BORDER]}
            />
            <UiButton
              type="submit"
              content="Je m'abonne"
              onClick={(e) => {
                handleSubmit(e,isFormInValid);
              }}
            />
          </div>
        </form>
      </Container>
    </React.Fragment>
  );
};

export default NewsletterCollector;
